<template>
  <div class="provider-applications-active">
    <Card class="w-full">
      <h2 class="text-h4">Apply to your first job</h2>
      <img src="../../../images/applications/applications-empty-state.svg" alt="No jobs" class="w-full h-auto mt-16" />
      <Button class="w-full mt-16" variant="secondary" to="/provider/jobs/search">Find Jobs</Button>
    </Card>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';

export default defineComponent({
  name: 'ProviderApplicationsActive',
  components: { Card, Button },
});
</script>
